module.exports = __webpack_public_path__ + "static/media/SH 28.563f529c.mp3";